import { render, staticRenderFns } from "./AgreementGSMA.vue?vue&type=template&id=2ac885a2&scoped=true"
import script from "./AgreementGSMA.vue?vue&type=script&lang=js"
export * from "./AgreementGSMA.vue?vue&type=script&lang=js"
import style0 from "./AgreementGSMA.vue?vue&type=style&index=0&id=2ac885a2&prod&lang=scss&scoped=true"
import style1 from "./AgreementGSMA.vue?vue&type=style&index=1&id=2ac885a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac885a2",
  null
  
)

export default component.exports